module.exports = __webpack_public_path__ + "static/media/client_1.c6e080e6.jpeg";